/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

/**
 * @param {HTMLElement} target
 * @returns {boolean}
 */
export const isAllowedEvtTarget = (target) => {
    const allowedTags = ['INPUT', 'TEXTAREA'];
    const allowedInputTypes = ['text', 'password', 'email', 'number', 'search', 'tel', 'url'];
    if (allowedTags.includes(target.tagName)) {
        const inputType = target.getAttribute('type');
        if (allowedInputTypes.includes(inputType) || !inputType) {
            return true;
        }
    } else if (target.closest('[contenteditable], [data-allow-copy]')) {
        return true;
    }
    return false;
};
